import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
  addDays,
} from "../../../utils";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Input from "sushiweb/InputTypes/Input";
import Checkbox from "sushiweb/InputTypes/Checkbox";
import * as RiderOfferActions from "../../../store/actions/RiderOfferActions";
import * as UserActions from "../../../store/actions/User";
import styles from "../../../constants/assets/variables";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const toDateString = (date) => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};

const getInitialState = () => {
  return {
    driver_id: "",
    start_date: toDateString(new Date(Date.now())),
    end_date: toDateString(new Date(Date.now())),
    is_achieved: false,
  };
};

const RiderOffersFilterModal = (props) => {
  const {
    handleClose,
    activeFilters,
    filterFields,
    getRiderOffers,
    resetState,
    setStatus,
  } = props;
  const [initialState, setInitialState] = useState(getInitialState());
  const [currentDate, setCurrentDate] = useState();

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(
      body,
      Object.keys(initialState)
    );
    if (validationState !== "validated") {
      hasNoErrors = false;

      setStatus({
        type: "error",
        message: "Driver ID, Date Range are mandatory",
      });
    }
    if (body["start_date"] && body["end_date"]) {
      let endDate = new Date(body["end_date"]);
      let startDate = new Date(body["start_date"]);
      if (startDate > endDate) {
        hasNoErrors = false;
        setStatus({
          type: "error",
          message: "Start date should come before end date",
        });
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e && e.preventDefault();

    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key];
      }
    }

    getRiderOffers(filters).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetState();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  useEffect(() => {
    // set max date
    setCurrentDate(new Date().toISOString().substring(0, 10));
    //set the initial state of form in modal
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading="Rider Offers Filter"
      handleClose={handleClearFilters}
      id="riderOffersFilterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button onClick={handleClearFilters} className="sushi-btn">
            Clear
          </Button>
          <Button onClick={handleSubmit} className="sushi-btn">
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.driver_id}
          onChange={(e) => handleChange("driver_id", e)}
          id="sushi-input"
          data-testId="DriverId"
          label="Driver ID / FE ID"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          autoFocus={true}
        />
        <Input
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Date"
          type="date"
          value={initialState.start_date ? initialState.start_date : "  "}
          onChange={(e) => handleChange("start_date", e)}
          fullWidth={true}
        />
        <Input
          id="sushi-input"
          label="End Date"
          type="date"
          value={initialState.end_date ? initialState.end_date : "  "}
          onChange={(e) => handleChange("end_date", e)}
          fullWidth={true}
          borderColor={styles.primaryColor}
        />
        <Checkbox
          label="Show only achieved offers"
          value="is_achieved"
          color={styles.red500}
          checked={initialState.is_achieved}
          onChange={(e) => handleChange("is_achieved", e.is_achieved)}
          className="sushi-checkbox mb-20"
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { RiderOffers } = state;
  return {
    activeFilters: RiderOffers.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetState: () => dispatch(RiderOfferActions.resetState({})),
    getRiderOffers: bindActionCreators(
      RiderOfferActions.getRiderOffers,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RiderOffersFilterModal);
